var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect, _rect2, _rect3, _rect4, _path17, _path18, _path19, _path20, _rect5, _rect6, _rect7, _rect8, _path21, _path22, _path23, _path24, _path25, _path26, _rect9, _rect10, _rect11, _rect12, _path27, _path28, _path29, _path30, _rect13, _rect14, _rect15, _rect16, _path31, _path32, _path33, _path34, _rect17, _rect18, _rect19, _rect20, _path35, _path36, _path37, _path38, _rect21, _rect22, _rect23, _rect24, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActividadInicio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1548.6 264.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e2d1f1;}.cls-2{fill:#434341;}.cls-3{fill:#ffb4e6;}.cls-4{fill:#fff;}.cls-5{fill:#c8a4e4;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M850.29,94.22l35.8,145.89a2.6,2.6,0,0,0,3.15,1.9l33-8.27a2.58,2.58,0,0,0,1.89-3.13L905,152.48,888.33,84.72a2.59,2.59,0,0,0-3.15-1.9L866,87.64l-13.77,3.44A2.6,2.6,0,0,0,850.29,94.22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M888.6,244a4.52,4.52,0,0,1-4.37-3.43L848.44,94.67a4.51,4.51,0,0,1,3.28-5.44l33-8.27a4.52,4.52,0,0,1,5.47,3.3L926,230.16a4.51,4.51,0,0,1-3.28,5.44l-33,8.26A4.67,4.67,0,0,1,888.6,244ZM852.15,93.76,888,239.65a.63.63,0,0,0,.3.42.67.67,0,0,0,.52.08l33-8.26a.68.68,0,0,0,.49-.82L886.47,85.17a.73.73,0,0,0-.31-.42.69.69,0,0,0-.51-.07l-33,8.26a.68.68,0,0,0-.5.82Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M809.82,94.22l35.79,145.89a2.6,2.6,0,0,0,3.15,1.9l33-8.27a2.58,2.58,0,0,0,1.88-3.13L847.85,84.72a2.59,2.59,0,0,0-3.15-1.9l-33,8.26A2.6,2.6,0,0,0,809.82,94.22Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M848.12,244a4.52,4.52,0,0,1-4.37-3.43L808,94.67a4.51,4.51,0,0,1,3.28-5.44l33-8.27a4.52,4.52,0,0,1,5.47,3.3l35.79,145.9a4.51,4.51,0,0,1-3.28,5.44l-33,8.26A4.54,4.54,0,0,1,848.12,244ZM811.68,93.76l35.79,145.89a.67.67,0,0,0,.31.42.64.64,0,0,0,.51.08l33-8.26a.68.68,0,0,0,.5-.82L846,85.17a.73.73,0,0,0-.31-.42.68.68,0,0,0-.51-.07l-33,8.26a.68.68,0,0,0-.49.82Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M802.77,201.71H647.91c-2.09,0-3.78.86-3.78,1.92v35.54c0,1.06,1.69,1.92,3.78,1.92H802.77c2.09,0,3.79-.86,3.79-1.92V203.63C806.56,202.57,804.86,201.71,802.77,201.71Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M802.77,243H647.91c-3.3,0-5.7-1.61-5.7-3.83V203.63c0-2.22,2.4-3.83,5.7-3.83H802.77c3.3,0,5.7,1.61,5.7,3.83v35.54C808.47,241.39,806.07,243,802.77,243ZM646,238.79a3.94,3.94,0,0,0,1.87.39H802.77a3.94,3.94,0,0,0,1.87-.39V204a4,4,0,0,0-1.87-.38H647.91A4,4,0,0,0,646,204Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M802.77,162.5H647.91c-2.09,0-3.78.86-3.78,1.92V200c0,1.07,1.69,1.93,3.78,1.93H802.77c2.09,0,3.79-.86,3.79-1.93V164.42C806.56,163.36,804.86,162.5,802.77,162.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M802.77,203.79H647.91c-3.3,0-5.7-1.61-5.7-3.84V164.42c0-2.22,2.4-3.84,5.7-3.84H802.77c3.3,0,5.7,1.62,5.7,3.84V200C808.47,202.18,806.07,203.79,802.77,203.79ZM646,199.58a4.1,4.1,0,0,0,1.87.38H802.77a4.1,4.1,0,0,0,1.87-.38V164.79a4.1,4.1,0,0,0-1.87-.38H647.91a4.1,4.1,0,0,0-1.87.38Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M802.77,123.28H647.91c-2.09,0-3.78.86-3.78,1.92v35.54c0,1.06,1.69,1.92,3.78,1.92H802.77c2.09,0,3.79-.86,3.79-1.92V125.2C806.56,124.14,804.86,123.28,802.77,123.28Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M802.77,164.57H647.91c-3.3,0-5.7-1.61-5.7-3.83V125.2c0-2.22,2.4-3.83,5.7-3.83H802.77c3.3,0,5.7,1.61,5.7,3.83v35.54C808.47,163,806.07,164.57,802.77,164.57ZM646,160.36a3.94,3.94,0,0,0,1.87.39H802.77a3.94,3.94,0,0,0,1.87-.39V125.58a4.1,4.1,0,0,0-1.87-.38H647.91a4.1,4.1,0,0,0-1.87.38Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M802.77,85.29H647.91c-2.09,0-3.78.86-3.78,1.93v35.53c0,1.06,1.69,1.92,3.78,1.92H802.77c2.09,0,3.79-.86,3.79-1.92V87.22C806.56,86.15,804.86,85.29,802.77,85.29Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M802.77,126.59H647.91c-3.3,0-5.7-1.62-5.7-3.84V87.22c0-2.23,2.4-3.84,5.7-3.84H802.77c3.3,0,5.7,1.61,5.7,3.84v35.53C808.47,125,806.07,126.59,802.77,126.59ZM646,122.37a3.94,3.94,0,0,0,1.87.39H802.77a3.94,3.94,0,0,0,1.87-.39V87.59a4.1,4.1,0,0,0-1.87-.38H647.91a4.1,4.1,0,0,0-1.87.38Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1330.13,70a2.37,2.37,0,0,1-1.91-3.78l18.63-25.4a2.38,2.38,0,0,1,3.84,2.82l-18.64,25.39A2.37,2.37,0,0,1,1330.13,70Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1294.37,118.77a2.37,2.37,0,0,1-1.92-3.78l18.64-25.4a2.38,2.38,0,1,1,3.83,2.82l-18.63,25.39A2.4,2.4,0,0,1,1294.37,118.77Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1310.57,73.57a2.37,2.37,0,0,1-1.4-.46l-25.39-18.64a2.38,2.38,0,0,1,2.81-3.83L1312,69.28a2.38,2.38,0,0,1-1.41,4.29Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1359.3,109.33a2.37,2.37,0,0,1-1.4-.46l-25.4-18.64a2.38,2.38,0,0,1,2.82-3.83L1360.71,105a2.38,2.38,0,0,1-1.41,4.29Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1313.89,
    y: 34.34,
    width: 4.75,
    height: 23.84,
    transform: "translate(8.21 200.14) rotate(-8.72)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1324.21,
    y: 101.66,
    width: 4.75,
    height: 23.84,
    transform: "translate(-1.88 202.48) rotate(-8.72)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1276.62,
    y: 82.53,
    width: 23.84,
    height: 4.75,
    transform: "translate(2.05 196.68) rotate(-8.74)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1343.94,
    y: 72.2,
    width: 23.84,
    height: 4.75,
    transform: "translate(4.34 206.13) rotate(-8.71)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M126.56,179.63a1.53,1.53,0,0,1-.93-.31,1.56,1.56,0,0,1-.34-2.2l16.77-22.84a1.57,1.57,0,0,1,2.54,1.86L127.83,179A1.59,1.59,0,0,1,126.56,179.63Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M94.39,223.46a1.64,1.64,0,0,1-.94-.3,1.58,1.58,0,0,1-.33-2.21l16.76-22.84a1.58,1.58,0,1,1,2.54,1.87L95.66,222.82A1.58,1.58,0,0,1,94.39,223.46Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M109,182.8a1.55,1.55,0,0,1-.93-.31L85.19,165.73a1.58,1.58,0,1,1,1.87-2.54L109.9,180a1.58,1.58,0,0,1-.94,2.85Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M152.8,215a1.61,1.61,0,0,1-.93-.3L129,197.9a1.57,1.57,0,1,1,1.86-2.54l22.84,16.76a1.58,1.58,0,0,1-.93,2.85Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 112.5,
    y: 148.08,
    width: 3.15,
    height: 21.44,
    transform: "translate(-22.77 19.14) rotate(-8.72)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 121.8,
    y: 208.63,
    width: 3.15,
    height: 21.44,
    transform: "translate(-31.84 21.24) rotate(-8.72)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 78.42,
    y: 191.99,
    width: 21.44,
    height: 3.15,
    transform: "translate(-28.36 15.78) rotate(-8.74)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 138.98,
    y: 182.69,
    width: 21.44,
    height: 3.15,
    transform: "translate(-26.25 24.87) rotate(-8.74)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M624.31,65.64c-1.07,6.47-2,13-3.24,19.4-4.54,23.36-17.4,41.47-35.55,56.3-11.52,9.42-22.8,19.13-34.3,28.58a6.31,6.31,0,0,0-2.59,5.56q.18,12.44,0,24.89c0,1.26-.54,3-1.46,3.69-6.06,4.28-12.29,8.32-18.85,12.7-2-7.12-3.82-13.89-5.67-20.66-1-3.72-2.55-4.81-5.65-2.77-6.68,4.41-12,2.32-16.78-2.75-3.86-4.05-7.58-8.24-11.19-12.52a6.19,6.19,0,0,1-.69-7.79,21.56,21.56,0,0,0,1.7-3.64c1.17-3,.1-5.1-3.06-6l-20.36-5.6c4.43-6.64,8.54-12.95,12.87-19.11.58-.83,2.27-1.2,3.46-1.21,8.05-.11,16.11-.16,24.16,0,2.48,0,4-.89,5.51-2.7,12-14,24-28,36.23-41.72,14.65-16.48,33.77-24.74,54.92-29,4.62-.93,9.31-1.52,14-2.26h6.6ZM576.38,93.4a13.73,13.73,0,0,0-14,13.49A14,14,0,0,0,576.28,121,13.78,13.78,0,0,0,590,107.16,13.53,13.53,0,0,0,576.38,93.4Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M459.5,213.61c.74-3.79,1.34-7.61,2.25-11.36,2.5-10.32,7.05-19.42,16-25.93,2.24,1.66,1.92,3.2.51,5.41-5.84,9.15-7.43,19.36-7.19,30.48,11,.41,21.24-1.36,30.57-7.08,2.64-1.61,2.62-1.65,5.45.29-6.4,9.09-15.6,13.64-26,16.18-3.74.92-7.56,1.52-11.35,2.26H459.5Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M914.05,43.37a1,1,0,0,1-.82-1.61l7.95-10.83a1,1,0,0,1,1.42-.21,1,1,0,0,1,.21,1.41L914.87,43A1,1,0,0,1,914.05,43.37Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M898.81,64.14a1,1,0,0,1-.82-1.61l7.94-10.82a1,1,0,0,1,1.42-.22,1,1,0,0,1,.22,1.41l-8,10.83A1,1,0,0,1,898.81,64.14Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M905.71,44.87a1,1,0,0,1-.59-.19l-10.83-8a1,1,0,0,1-.22-1.41,1,1,0,0,1,1.42-.22L906.31,43a1,1,0,0,1-.6,1.83Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M926.48,60.12a1,1,0,0,1-.59-.2L915.06,52a1,1,0,0,1,1.2-1.64l10.83,7.95a1,1,0,0,1,.21,1.42A1,1,0,0,1,926.48,60.12Z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 907.12,
    y: 28.15,
    width: 2.03,
    height: 10.16,
    transform: "translate(5.46 138.1) rotate(-8.72)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 911.53,
    y: 56.85,
    width: 2.03,
    height: 10.16,
    transform: "translate(1.16 139.1) rotate(-8.72)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 891.24,
    y: 48.7,
    width: 10.16,
    height: 2.03,
    transform: "translate(2.85 136.7) rotate(-8.74)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 919.94,
    y: 44.29,
    width: 10.16,
    height: 2.03,
    transform: "translate(3.85 141.01) rotate(-8.74)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1308.7,228a1.41,1.41,0,0,1-1.13-2.25l11.07-15.07a1.41,1.41,0,1,1,2.27,1.67l-11.07,15.08A1.41,1.41,0,0,1,1308.7,228Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1287.47,257a1.39,1.39,0,0,1-.84-.28,1.41,1.41,0,0,1-.3-2l11.07-15.08a1.41,1.41,0,0,1,2.27,1.67l-11.06,15.08A1.42,1.42,0,0,1,1287.47,257Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1297.09,230.13a1.35,1.35,0,0,1-.83-.27l-15.08-11.07a1.41,1.41,0,1,1,1.67-2.27l15.08,11.07a1.41,1.41,0,0,1-.84,2.54Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1326,251.37a1.45,1.45,0,0,1-.84-.27L1310.11,240a1.42,1.42,0,0,1-.3-2,1.4,1.4,0,0,1,2-.3l15.08,11.06a1.41,1.41,0,0,1-.83,2.55Z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1299.06,
    y: 206.84,
    width: 2.82,
    height: 14.16,
    transform: "translate(-17.4 199.68) rotate(-8.72)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1305.19,
    y: 246.82,
    width: 2.82,
    height: 14.16,
    transform: "translate(-23.39 201.07) rotate(-8.72)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1276.93,
    y: 235.46,
    width: 14.16,
    height: 2.82,
    transform: "translate(-21.08 197.75) rotate(-8.74)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1316.9,
    y: 229.32,
    width: 14.16,
    height: 2.82,
    transform: "translate(-19.68 203.75) rotate(-8.74)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M320.55,61a1.34,1.34,0,0,1-1.34-1.33l-.47-30.9a1.35,1.35,0,0,1,2.7,0l.46,30.9A1.34,1.34,0,0,1,320.58,61Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M321.45,120.31A1.35,1.35,0,0,1,320.1,119l-.47-30.9A1.35,1.35,0,0,1,321,86.71,1.31,1.31,0,0,1,322.33,88l.47,30.9a1.36,1.36,0,0,1-1.33,1.37Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M276.45,75.82a1.35,1.35,0,0,1,0-2.7l30.9-.46a1.35,1.35,0,1,1,0,2.69l-30.9.47Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M335.74,74.92a1.35,1.35,0,0,1,0-2.69l30.9-.47A1.39,1.39,0,0,1,368,73.09a1.35,1.35,0,0,1-1.32,1.37l-30.91.46Z"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 295.68,
    y: 39.45,
    width: 2.7,
    height: 23.39,
    transform: "translate(53.48 228.69) rotate(-45.86)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 343.64,
    y: 85.98,
    width: 2.7,
    height: 23.39,
    transform: "translate(34.65 277.24) rotate(-45.86)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 286.55,
    y: 96.44,
    width: 23.39,
    height: 2.7,
    transform: "translate(20.39 243.77) rotate(-45.87)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 333.08,
    y: 48.48,
    width: 23.39,
    height: 2.7,
    transform: "translate(68.95 262.6) rotate(-45.87)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1459.86,104.15a1.15,1.15,0,0,1-.7-.23,1.19,1.19,0,0,1-.26-1.67l9.39-12.79a1.2,1.2,0,0,1,1.93,1.41l-9.39,12.79A1.19,1.19,0,0,1,1459.86,104.15Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1441.85,128.69a1.15,1.15,0,0,1-.7-.23,1.19,1.19,0,0,1-.26-1.67l9.39-12.79a1.19,1.19,0,1,1,1.92,1.41l-9.38,12.79A1.21,1.21,0,0,1,1441.85,128.69Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1450,105.93a1.23,1.23,0,0,1-.71-.23l-12.79-9.39a1.2,1.2,0,1,1,1.42-1.93l12.78,9.38a1.2,1.2,0,0,1,.26,1.68A1.19,1.19,0,0,1,1450,105.93Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1474.55,123.94a1.22,1.22,0,0,1-.7-.23l-12.79-9.39a1.2,1.2,0,1,1,1.42-1.93l12.78,9.38a1.2,1.2,0,0,1-.71,2.17Z"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1451.68,
    y: 86.17,
    width: 2.39,
    height: 12,
    transform: "translate(2.83 221.42) rotate(-8.72)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1456.88,
    y: 120.07,
    width: 2.39,
    height: 12,
    transform: "translate(-2.26 222.57) rotate(-8.72)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1432.92,
    y: 110.44,
    width: 12,
    height: 2.39,
    transform: "translate(-0.29 219.48) rotate(-8.72)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1466.82,
    y: 105.24,
    width: 12,
    height: 2.39,
    transform: "translate(0.89 224.56) rotate(-8.72)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M942.29,99.15h6.21l14.35,15v-15h9.27v31.49H965.6l-14.09-15v15h-9.22Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M978,99.15h9.5v18a5.68,5.68,0,0,0,1.37,4,4.66,4.66,0,0,0,3.62,1.5,4.56,4.56,0,0,0,3.56-1.5,5.76,5.76,0,0,0,1.35-4v-18h9.49V118a12.55,12.55,0,0,1-4,9.66q-4,3.66-10.44,3.67A14.93,14.93,0,0,1,982,127.7a12.48,12.48,0,0,1-4-9.66Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1012.76,99.15h24.29v8h-14.8v3.74H1035v7.74h-12.73v4h15.25v8h-24.74Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1041,99.15h10.35l6.93,19.21L1065,99.15h10.35l-12.91,31.49H1054Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1073.46,130.64l13-31.49h8.5l12.91,31.49h-10.34l-1.54-4.36h-10.61l-1.58,4.36Zm19.71-12.32-2.43-6.89-2.47,6.89Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M940.4,184.64l13-31.49h8.51l12.91,31.49H964.47l-1.53-4.36H952.32l-1.57,4.36Zm19.71-12.32-2.43-6.89-2.48,6.89Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M997.68,166.42a7.2,7.2,0,0,0,.23-1.75,3,3,0,0,0-1.53-2.5,7.77,7.77,0,0,0-9.23,1.17,8.92,8.92,0,0,0,0,11.16,6.7,6.7,0,0,0,5.22,2.13,6,6,0,0,0,4.16-1.37,5.36,5.36,0,0,0,1.78-3.62h9a14.36,14.36,0,0,1-4.95,9.86,15.84,15.84,0,0,1-10.8,3.87,15.09,15.09,0,0,1-11.43-4.62,17.81,17.81,0,0,1,.2-23.69q4.61-4.63,12.08-4.63a16.36,16.36,0,0,1,10.4,3.21,10,10,0,0,1,4.09,8.22,6.49,6.49,0,0,1-.49,2.56Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1029.68,161.11v23.53h-9.5V161.11h-9.49v-8h28.48v8Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1043.63,153.15h9.49v31.49h-9.49Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1057.31,153.15h10.34l6.93,19.21,6.8-19.21h10.35l-12.92,31.49h-8.5Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1096,153.15h9.5v31.49H1096Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1111.53,153.15h13.72a16.82,16.82,0,0,1,12,4.43,14.85,14.85,0,0,1,4.7,11.32,14.65,14.65,0,0,1-4.79,11.38,17.07,17.07,0,0,1-12,4.36h-13.72Zm13.72,23.48a6.8,6.8,0,0,0,5.2-2.18,7.75,7.75,0,0,0,2-5.55,7.87,7.87,0,0,0-2-5.61,6.83,6.83,0,0,0-5.2-2.18H1121v15.52Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1142.85,184.64l13-31.49h8.51l12.91,31.49h-10.35l-1.53-4.36h-10.62l-1.57,4.36Zm19.71-12.32-2.43-6.89-2.48,6.89Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1181.5,153.15h13.73a16.84,16.84,0,0,1,12,4.43,14.88,14.88,0,0,1,4.7,11.32,14.68,14.68,0,0,1-4.79,11.38,17.09,17.09,0,0,1-12,4.36H1181.5Zm13.73,23.48a6.81,6.81,0,0,0,5.2-2.18,7.79,7.79,0,0,0,2-5.55,7.9,7.9,0,0,0-2-5.61,6.85,6.85,0,0,0-5.2-2.18H1191v15.52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActividadInicio);
export default __webpack_public_path__ + "static/media/Actividad_inicio.3013e92b18b51654157b6e6fa3f8fb8d.svg";
export { ForwardRef as ReactComponent };